<template>
  <div id="app">
    <router-view/>
    <modal-post-window :show-modal="showModal" :current-data="currentData"/>
  </div>
</template>

<script>
  import ModalPostWindow from './components/modal/ModalPostWindow.vue';

  export default {
    components: { ModalPostWindow },
    data() {
      return {
        showModal: false,
        currentData: {},
      };
    },
    methods: {
      toStaticBody() {
        const docBody = document.querySelector('body');

        if(this.showModal) {
          docBody.setAttribute('style', 'overflow-y: hidden');
        }else{
          docBody.setAttribute('style', 'overflow-y: auto');
        }
      }
    },
    mounted() {
      this.$root.$on('togglePostToModal', ({target, post = undefined}) => {
        if (post) {
          this.currentData = { ...post };
          this.showModal = true;
        } else {
          if(target.className.includes('popup')) {
            this.showModal = false;
          }
        }

        this.toStaticBody();
      });
    },
  };
</script>

<style>
@import "./assets/css/material.css";

html,
body {
  height: 100%;
  min-width: 320px;
  background-color: #ffffff;
  font-family: "Roboto", "Arial", sans-serif;
  font-weight: 400;
  color: #000000;
  font-size: 12px;
  line-height: 18px;
  padding: 0;
  margin: 0;
}

#app {
  height: 100%;
}
</style>
